import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { ProjektStatiQuerySorterConfig } from 'fa-kt.types';
import { ProjektStatiService } from '../service';

@Component({
  selector: 'fa-kt-projekt-stati-sorter',
  templateUrl: './projekt-stati-sorter.component.html',
  styleUrls: ['./projekt-stati-sorter.component.css'],
})
export class ProjektStatiSorterComponent {
  ProjektStatiSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public projektStati: ProjektStatiService,
  ) {
    this.ProjektStatiSorterConfig = ProjektStatiQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
